/**
 * HL Holdings Main Application
 * Legacy compatibility wrapper - imports Application class
 */

// ES Module 방식으로 Application 클래스 import
import { Application } from "./Application.js";

// 전역 인스턴스 생성
const app = new Application();

// 전역 접근을 위한 window 객체에 할당
window.app = app;

export default app;
